import React, { useCallback } from "react";
import { useHistory } from "react-router";
import { AiBrandInsightsSummary } from "@yoast/ai-insights-client";
import { getAccessToken } from "shared-frontend/functions/auth";
import getEnv from "shared-frontend/functions/getEnv";

import { aiBrandInsightsPath } from "../../config/Menu";

const apiUrl = getEnv( "AIBI_API_URL", "http://127.0.0.1:8000/api/v1" );

/**
 * Homepage card that shows a compact AI Brand Insights summary for the user's
 * brand, with a call-to-action to open the full tool (or to get started when
 * the user has no brand/license yet).
 *
 * @returns {ReactElement} The AI Brand Insights summary Card.
 */
const AiBrandInsightsCard = () => {
	const history = useHistory();

	return (
		<AiBrandInsightsSummary
			apiUrl={ apiUrl }
			token={ useCallback( () => getAccessToken(), [] ) }
			onNavigate={ ( to ) => history.push( `${aiBrandInsightsPath}${to}` ) }
			hrefFor={ ( to ) => `${aiBrandInsightsPath}${to}` }
			// Named target so the tool opens in — and reuses — its own tab,
			// matching the AI navigation menu (see Menu.jsx aiBrandInsightsPath).
			linkTarget="aiBrandInsights"
		/>
	);
};

export default AiBrandInsightsCard;
